import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './user.state';

export const selectUserState = createFeatureSelector<UserState>('user');

export const selectUser = createSelector(selectUserState, (state) => state.user);
export const selectLoading = createSelector(selectUserState, (state) => state.loading);
export const selectError = createSelector(selectUserState, (state) => state.error);
export const selectIsAuthenticated = createSelector(selectUserState, (state) => state.isAuthenticated);

export const selectUserRole = createSelector(selectUser, (user) => user?.role);
export const selectUserAdditionalRoles = createSelector(selectUser, (user) => user?.additionalRoles ?? []);
export const selectUserEmail = createSelector(selectUser, (user) => user?.email);
export const selectUserFullName = createSelector(selectUser, (user) =>
  user ? `${ user.firstName } ${ user.lastName }` : null,
);
export const selectUpdateProfileLoading = createSelector(selectUserState, (state) => state.updateProfileLoading);
export const selectUpdateProfileError = createSelector(selectUserState, (state) => state.updateProfileError);
export const selectPhotoUploading = createSelector(selectUserState, (state) => state.photoUploading);
export const selectPhotoDeleting = createSelector(selectUserState, (state) => state.photoDeleting);
